import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import embed from 'vega-embed';
import autocomplete from 'autocomplete.js';
import Chart from 'chart.js/auto';

// Add a polyfill for NodeList.forEach for Edge browser, see https://stackoverflow.com/a/51970214
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

function initTransactionForm() {
    let form = document.getElementById('transaction_form');
    if (!form) {
        return;
    }

    let typeInput = document.getElementById('type');
    let amountInput = document.getElementById('amount');
    let quantityInput = document.getElementById('quantity');
    let unitPriceInput = document.getElementById('unit_price');
    let multiplierInput = document.getElementById('multiplier');
    let currencyInput = document.getElementById('currency_code');

    let amountCurrencyEl = document.getElementById('amount_currency');
    let unitPriceCurrencyEl = document.getElementById('unit_price_currency');

    let securityInputGroup = document.getElementById('security_input_group');
    let quantityInputGroup = document.getElementById('quantity_input_group');
    let unitPriceInputGroup = document.getElementById('unit_price_input_group');

    function recalculateAmount() {
        var multiplier = 1;
        if (multiplierInput.value) {
            multiplier = multiplierInput.value;
        }
        amountInput.value = -1 * quantityInput.value * unitPriceInput.value * multiplier;
    }

    typeInput.addEventListener('change', function (event) {
        if (['trade', 'transfer', 'fund_conversion', 'fee', 'dividend', 'coupon', 'stock_split'].indexOf(event.target.value) >= 0) {
            securityInputGroup.classList.remove('hidden');
        } else {
            securityInputGroup.classList.add('hidden');
        }

        if (['trade', 'transfer', 'fund_conversion', 'stock_split'].indexOf(event.target.value) >= 0) {
            quantityInputGroup.classList.remove('hidden');
            unitPriceInputGroup.classList.remove('hidden');
            amountInput.readOnly = true;
            // amountInput.value = '';
            recalculateAmount();
        } else {
            quantityInputGroup.classList.add('hidden');
            unitPriceInputGroup.classList.add('hidden');
            // quantityInput.value = '';
            // unitPriceInput.value = '';
            amountInput.readOnly = false;
        }
    });

    quantityInput.addEventListener('input', function (event) {
        recalculateAmount();
    });

    unitPriceInput.addEventListener('input', function (event) {
        recalculateAmount();
    });

    currencyInput.addEventListener('input', function (event) {
        amountCurrencyEl.textContent = event.target.value;
        unitPriceCurrencyEl.textContent = event.target.value;
    });

    form.addEventListener('submit', function (event) {
        if (['trade', 'transfer', 'fund_conversion', 'stock_split'].indexOf(typeInput.value) < 0) {
            quantityInput.value = '';
            unitPriceInput.value = '';
        }
    });
}

function initSecuritiesAutocomplete(name) {
    function doSearch(query, cb) {
        let params = new URLSearchParams({q: query})
        fetch(`/symbols?${params}`, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(response => {
            return response.json()
        }).then(function (data) {
            cb(data);
        });
    }

    document.getElementById(`${name}_name`).addEventListener('input', (event) => {
        if (event.target.value === '') {
            document.getElementById(`${name}_id_type`).value = '';
            document.getElementById(`${name}_id`).value = '';
        }
    });

    autocomplete(`#${name}_name`, {hint: false}, [
        {
            source: doSearch,
            displayKey: 'name',
            templates: {
                suggestion: function (suggestion) {
                    return `<p>${suggestion.name}</p><small>${suggestion.id}</small>`
                }
            }
        }
    ]).on('autocomplete:selected', function (event, suggestion, dataset, context) {
        document.getElementById(`${name}_id_type`).value = suggestion.id_type;
        document.getElementById(`${name}_id`).value = suggestion.id;
    });
}

function initDropArea() {
    let dropArea = document.getElementById('drop-area');
    if (!dropArea) {
        return;
    }
    let loaderEl = dropArea.getElementsByClassName('spinner')[0];
    let textEl = document.getElementById('upload-form-desc');
    let filesInput = document.getElementById('files');

    function highlight() {
        dropArea.classList.remove("border-gray-200");
        dropArea.classList.add("border-gray-400", "bg-gray-200");
    }

    function unhighlight() {
        dropArea.classList.remove("border-gray-400", "bg-gray-200");
        dropArea.classList.add("border-gray-200");
    }

    function allowDrop(e) {
        if (e.dataTransfer.types.includes('Files')) {
            e.preventDefault();
            // Style the drag-and-drop as a "copy file" operation.
            e.dataTransfer.dropEffect = 'copy';
            highlight();
        }
    }
    ;['dragenter', 'dragover'].forEach(eventName => {
        dropArea.addEventListener(eventName, allowDrop, false);
    });

    function submitForm() {
        loaderEl.classList.remove('hidden');
        textEl.textContent = 'Uploading files...';
        filesInput.form.submit();
    }

    filesInput.addEventListener('change', function () {
        submitForm();
    });

    dropArea.addEventListener('dragleave', function (event) {
        unhighlight();
    })

    dropArea.addEventListener('drop', (event) => {
        event.stopPropagation();
        event.preventDefault();

        unhighlight();

        filesInput.files = event.dataTransfer.files;
        submitForm();
    });
}

function renderBreakdownChart(chartElId, rows, displayLegend = true) {
    const labels = rows.map(row => row['name']);

    const data = {
        labels: labels,
        datasets: [{
            data: rows.map(row => row['weight']),
            backgroundColor: [
                '#4e79a7',
                '#f28e2c',
                '#e15759',
                '#76b7b2',
                '#59a14f',
                '#edc949',
                '#af7aa1',
                '#ff9da7',
                '#9c755f',
                '#bab0ab',
            ]
        }]
    };

    const config = {
        type: 'doughnut',
        data: data,
        options: {
            plugins: {
                legend: {
                    position: 'bottom',
                    display: displayLegend
                },
                tooltip: {
                    callbacks: {
                        label: function (context) {
                            return context.label + ": " + Intl.NumberFormat("en-US", {style: "percent"}).format(context.parsed);
                        }
                    }
                }
            }
        }
    };

    const myChart = new Chart(
        document.getElementById(chartElId),
        config
    );
}

function renderPortfolioPerformanceChart(chartEl, data) {
    const vegaSpec = {
        "config": {
            "view": {"strokeWidth": 0}
        },
        "width": "container",
        "height": "container",
        "layer": [
            {
                "mark": {
                    "type": "rule",
                    "color": "rgb(45, 103, 247)",
                    "strokeOpacity": 0.1,
                    "size": 1,
                    "strokeDash": [5, 2]
                },
                "encoding": {"y": {"datum": 0}},
            },
            {
                "mark": {
                    "type": "area",
                    "color": {
                        "gradient": "linear",
                        "stops": [
                            {"color": "white", "offset": 0},
                            {"color": "rgb(45, 103, 247)", "offset": 1}
                        ],
                        "x1": 1,
                        "x2": 1,
                        "y1": 1,
                        "y2": 0
                    },
                    "line": {
                        "color": "rgb(45, 103, 247)",
                        "strokeWidth": 4,
                        "interpolate": "monotone"
                    },
                    "opacity": 0.1
                },
                "encoding": {
                    "tooltip": [
                        {"field": "date", "title": "Date", "type": "temporal"},
                        {
                            "field": "profit_loss_in_reporting_currency",
                            "format": ",.2f",
                            "title": "Value",
                            "type": "quantitative"
                        },
                    ],
                    "x": {
                        "axis": {
                            "domain": false,
                            "grid": false,
                            "labelColor": "#7F7F7F",
                            "labelFont": "Inter var",
                            "labelFontSize": 12
                        },
                        "field": "date",
                        "title": null,
                        "type": "temporal",
                        "scale": {
                            "type": "utc",
                        },
                    },
                    "y": {
                        "axis": {
                            "domain": false,
                            // "format": "+.0%",
                            "format": "~s",
                            "grid": false,
                            "labelPadding": 5,
                            "labelColor": "#7F7F7F",
                            "labelFont": "Inter var",
                            "labelFontSize": 12,
                            "orient": "right",
                            "ticks": false,
                        },
                        "field": "profit_loss_in_reporting_currency",
                        "title": null,
                        "type": "quantitative"
                    }
                }
            },
        ],
        "background": "transparent",
        "data": {"values": data},
        "$schema": "https://vega.github.io/schema/vega-lite/v4.17.0.json"
    };
    const embedOpt = {
        "mode": "vega-lite",
        "theme": "default",
        "actions": false,
        "renderer": 'svg'
    };
    embed(chartEl, vegaSpec, embedOpt);
}

function renderPortfolioValueChart(chartEl, data) {
    const vegaSpec = {
        "config": {
            "view": {"strokeWidth": 0}
        },
        "width": "container",
        "height": "container",
        "layer": [
            {
                "mark": {
                    "type": "line",
                    "color": "#d3d3d3",
                    "strokeWidth": 4,
                    "interpolate": "linear",
                },
                "encoding": {
                    "x": {
                        "axis": {"domain": false},
                        "field": "date_time",
                        "title": null,
                        "type": "temporal",
                        "scale": {
                            "type": "utc",
                        },
                    },
                    "y": {
                        "axis": {"domain": false},
                        "field": "benchmark_value_in_reporting_currency",
                        "title": null,
                        "type": "quantitative"
                    }
                }
            },
            {
                "mark": {
                    "type": "line",
                    "color": "rgb(45, 103, 247)",
                    "opacity": 0.3,
                    "strokeDash": [10, 2],
                    "strokeWidth": 3
                },
                "encoding": {
                    "x": {
                        "axis": {
                            "domain": false,
                            "grid": false,
                            "labelColor": "#7F7F7F",
                            "labelFont": "Inter var",
                            "labelFontSize": 12
                        },
                        "field": "date_time",
                        "title": null,
                        "type": "temporal",
                        "scale": {
                            "type": "utc",
                        },
                    },
                    "y": {
                        "axis": {
                            "domain": false,
                            "format": "~s",
                            "grid": false,
                            "labelColor": "#7F7F7F",
                            "labelFont": "Inter var",
                            "labelFontSize": 12,
                            "orient": "right"
                        },
                        "field": "cumulative_cost_in_reporting_currency",
                        "title": null,
                        "type": "quantitative"
                    }
                }
            },
            {
                "mark": {
                    "type": "area",
                    "color": {
                        "gradient": "linear",
                        "stops": [
                            {"color": "white", "offset": 0},
                            {"color": "rgb(45, 103, 247)", "offset": 1}
                        ],
                        "x1": 1,
                        "x2": 1,
                        "y1": 1,
                        "y2": 0
                    },
                    "line": {
                        "color": "rgb(45, 103, 247)",
                        "strokeWidth": 4,
                        "interpolate": "linear"
                    },
                    "opacity": 0.1
                },
                "encoding": {
                    "tooltip": [
                        {"field": "date_time", "title": "Date", "type": "temporal"},
                        {
                            "field": "portfolio_value_in_reporting_currency",
                            "format": ",.2f",
                            "title": "Value",
                            "type": "quantitative"
                        },
                        {
                            "field": "cumulative_cost_in_reporting_currency",
                            "format": ",.2f",
                            "title": "Cumulative cashflow",
                            "type": "quantitative"
                        }
                    ],
                    "x": {
                        "axis": {
                            "domain": false,
                            "grid": false,
                            "labelColor": "#7F7F7F",
                            "labelFont": "Inter var",
                            "labelFontSize": 12
                        },
                        "field": "date_time",
                        "title": null,
                        "type": "temporal",
                        "scale": {
                            "type": "utc",
                        },
                    },
                    "y": {
                        "axis": {
                            "domain": false,
                            "format": "~s",
                            "grid": false,
                            "labelPadding": 5,
                            "labelColor": "#7F7F7F",
                            "labelFont": "Inter var",
                            "labelFontSize": 12,
                            "orient": "right",
                            "ticks": false,
                        },
                        "field": "portfolio_value_in_reporting_currency",
                        "title": null,
                        "type": "quantitative"
                    }
                }
            },
        ],
        "background": "transparent",
        "data": {"values": data},
        "$schema": "https://vega.github.io/schema/vega-lite/v4.17.0.json"
    };
    const embedOpt = {
        "mode": "vega-lite",
        "theme": "default",
        "actions": false,
        "renderer": 'svg'
    };
    embed(chartEl, vegaSpec, embedOpt);
}

function renderDividendsChart(el, data) {
    const vegaSpec = {
        "config": {
            "view": {"strokeWidth": 0}
        },
        "width": "container",
        "height": "container",
        "data": {"values": data},
        "mark": "bar",
        "background": "transparent",
        "encoding": {
            "color": {
                "field": "security_name",
                "legend": null,
                "type": "nominal"
            },
            "tooltip": [
                {
                    "field": "date",
                    "timeUnit": "yearmonth",
                    "title": "Date",
                    "type": "temporal"
                },
                {
                    "field": "security_name",
                    "title": "Security",
                    "type": "nominal"
                },
                {
                    "aggregate": "sum",
                    "field": "amount_in_reporting_currency",
                    "format": ".2f",
                    "title": "Amount",
                    "type": "quantitative"
                }
            ],
            "x": {
                "axis": {
                    "domain": false,
                    "grid": false,
                    "labelColor": "#7F7F7F",
                    "labelFont": "Inter var",
                    "labelFontSize": 12
                },
                "field": "date",
                "timeUnit": "yearmonth",
                "title": null,
                "type": "temporal"
            },
            "y": {
                "aggregate": "sum",
                "axis": {
                    "domain": false,
                    "grid": false,
                    "labelColor": "#7F7F7F",
                    "labelFont": "Inter var",
                    "labelFontSize": 12
                },
                "field": "amount_in_reporting_currency",
                "title": null,
                "type": "quantitative"
            }
        },
        "$schema": "https://vega.github.io/schema/vega-lite/v4.17.0.json",
    };
    const embedOpt = {
        "mode": "vega-lite",
        "theme": "default",
        "actions": false,
        "renderer": 'svg'
    };
    embed(el, vegaSpec, embedOpt);
}

window.initSecuritiesAutocomplete = initSecuritiesAutocomplete;

document.addEventListener('DOMContentLoaded', (event) => {
    tippy('[data-tippy-content]', {interactive: true, allowHTML: true, appendTo: () => document.body});

    if (document.getElementById('security_name')) {
        initSecuritiesAutocomplete('security');
    }
    if (document.getElementById('benchmark_name')) {
        initSecuritiesAutocomplete('benchmark');
    }

    document.querySelectorAll('[data-portfolio-value-chart-data-container-id]').forEach(el => {
        const data = JSON.parse(document.getElementById(el.dataset.portfolioValueChartDataContainerId).textContent);
        renderPortfolioValueChart(el, data);
    });

    document.querySelectorAll('[data-dividends-chart-data-container-id]').forEach(el => {
        const data = JSON.parse(document.getElementById(el.dataset.dividendsChartDataContainerId).textContent);
        renderDividendsChart(el, data);
    });

    const chartSpecElements = document.querySelectorAll(".vega-spec");
    chartSpecElements.forEach(chartSpecElement => {
        var embedOpt = {
            "mode": "vega-lite",
            "theme": "default",
            "actions": false,
            "renderer": 'svg'
        };

        let spec = JSON.parse(chartSpecElement.textContent);

        let chartEl = document.getElementById(chartSpecElement.dataset.chartId);

        embed(chartEl, spec, embedOpt)
            .catch(console.error);
    });


    document.querySelectorAll('[data-portfolio-breakdown-weights-data-url]').forEach(el => {
        const dataUrl = el.dataset.portfolioBreakdownWeightsDataUrl;

        const assetClassWeightsChartId = el.dataset.assetClassWeightsChartId;
        const worldRegionWeightsChartId = el.dataset.worldRegionWeightsChartId;
        const sectorWeightsChartId = el.dataset.sectorWeightsChartId;

        fetch(dataUrl, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(response => {
            return response.json()
        }).then(function (data) {
            renderBreakdownChart(assetClassWeightsChartId, data['asset_class_weights'], false);
            renderBreakdownChart(worldRegionWeightsChartId, data['world_region_weights'], false);
            renderBreakdownChart(sectorWeightsChartId, data['sector_weights'], false);
        });
    });

    const chartDataElements = document.querySelectorAll(".chart-data");
    chartDataElements.forEach(chartDataElement => {
        const chartElId = chartDataElement.dataset.chartCanvasId;
        const showLegend = (chartDataElement.dataset.chartHideLegend == null)
        const rows = JSON.parse(chartDataElement.textContent);
        renderBreakdownChart(chartElId, rows, showLegend);
    });

    initDropArea();

    initTransactionForm();

    const currencyAmounts = document.querySelectorAll(".currency");
    currencyAmounts.forEach(currencyAmount => {
        currencyAmount.innerHTML = currencyAmount.textContent.replace(/([A-Z]{3})(\d+)/i, "$1<span style='white-space: nowrap;'>&thinsp;</span>$2");
    });

    const performanceChartButton = document.getElementById("performance-chart-button");
    if (performanceChartButton) {
        performanceChartButton.addEventListener('click', function (event) {
            event.target.classList.add('bg-white', 'shadow-sm');
            event.target.classList.remove('hover:bg-gray-50');
            document.getElementById("performance-chart-container").classList.remove('hidden');
            document.getElementById("performance-chart-container").style.display = 'block';

            document.querySelectorAll('[data-portfolio-performance-chart-data-container-id]').forEach(el => {
                const data = JSON.parse(document.getElementById(el.dataset.portfolioPerformanceChartDataContainerId).textContent);
                renderPortfolioPerformanceChart(el, data);
            });

            document.getElementById("value-chart-container").classList.add('hidden');
            document.getElementById("value-chart-container").innerHTML = '';
            document.getElementById("value-chart-container").style.display = 'none';
            document.getElementById("value-chart-button").classList.remove('bg-white', 'shadow-sm');
            document.getElementById("value-chart-button").classList.add('hover:bg-gray-50');
        });
    }

    const valueChartButton = document.getElementById("value-chart-button");
    if (valueChartButton) {
        valueChartButton.addEventListener('click', function (event) {
            event.target.classList.add('bg-white', 'shadow-sm');
            event.target.classList.remove('hover:bg-gray-50');
            document.getElementById("value-chart-container").classList.remove('hidden');
            document.getElementById("value-chart-container").style.display = 'block';

            document.querySelectorAll('[data-portfolio-value-chart-data-container-id]').forEach(el => {
                const data = JSON.parse(document.getElementById(el.dataset.portfolioValueChartDataContainerId).textContent);
                renderPortfolioValueChart(el, data);
            });

            document.getElementById("performance-chart-container").classList.add('hidden');
            document.getElementById("performance-chart-container").innerHTML = '';
            document.getElementById("performance-chart-container").style.display = 'none';
            document.getElementById("performance-chart-button").classList.remove('bg-white', 'shadow-sm');
            document.getElementById("performance-chart-button").classList.add('hover:bg-gray-50');
        });
    }
})

// function initFullscreenDropArea() {
//     // See https://codepen.io/nekobog/pen/JjoZvBm
//     // Completely based on this answer:
//     // http://stackoverflow.com/a/33917000
//     // … and the according JSfiddle:
//     // https://jsfiddle.net/oL2akhtz/
//     //
//     // Enhanced for my own purposes
//
//     let dropZone = document.getElementById('fullscreen-drop-area');
//
//     if (!dropZone) {
//         return;
//     }
//
//     function showDropZone() {
//         // dropZone.style.display = "block";
//         dropZone.classList.remove("hidden");
//         dropZone.classList.add("block");
//     }
//
//     function hideDropZone() {
//         // dropZone.style.display = "none";
//         dropZone.classList.add("hidden");
//         dropZone.classList.remove("block");
//     }
//
//     function allowDrop(e) {
//         if (true) {  // Test that the item being dragged is a valid one
//             e.dataTransfer.dropEffect = 'copy';
//             e.preventDefault();
//         }
//     }
//
//     function handleDrop(e) {
//         e.preventDefault();
//         hideDropZone();
//
//         alert('Drop!');
//     }
//
//     window.addEventListener('dragenter', function (e) {
//         showDropZone();
//     });
//
//     dropZone.addEventListener('dragenter', allowDrop);
//     dropZone.addEventListener('dragover', allowDrop);
//
//     dropZone.addEventListener('dragleave', function (e) {
//         hideDropZone();
//     });
//
//     dropZone.addEventListener('drop', handleDrop);
// }

// TABLE SORTING

// Function to sort table
function sortTable(table, sortKey, direction) {
    const tbody = table.querySelector('tbody');
    const rows = Array.from(tbody.querySelectorAll('tr'));

    rows.sort((rowA, rowB) => {
        const cellA = rowA.querySelector(`[data-sortable-key="${sortKey}"]`);
        const cellB = rowB.querySelector(`[data-sortable-key="${sortKey}"]`);
        const valueA = cellA?.dataset.sortableValue;
        const valueB = cellB?.dataset.sortableValue;

        // Check for missing data attributes
        if (valueA === undefined && valueB === undefined) return 0;
        if (valueA === undefined) return 1;
        if (valueB === undefined) return -1;

        const numA = parseFloat(valueA);
        const numB = parseFloat(valueB);

        let comparison;
        if (!isNaN(numA) && !isNaN(numB)) {
            comparison = numA - numB;
        } else {
            comparison = String(valueA).localeCompare(String(valueB));
        }

        return direction === 'asc' ? comparison : -comparison;
    });

    tbody.innerHTML = '';
    rows.forEach(row => tbody.appendChild(row));

    updateSortState(table, sortKey, direction);
}


// Function to update sort state
function updateSortState(table, sortKey, newDirection) {
    table.querySelectorAll('th [data-sortable-key]').forEach(div => {
        const key = div.dataset.sortableKey;
        const svg = div.querySelector('svg');
        if (key === sortKey) {
            div.dataset.sortDirection = newDirection;
        } else {
            div.dataset.sortDirection = '';
        }
        updateSvgState(svg, div.dataset.sortDirection);
    });
}

// Function to update SVG state
function updateSvgState(svg, direction) {
    const paths = svg.querySelectorAll('path');
    if (direction === 'asc') {
        paths[0].setAttribute('d', "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z");
        paths[0].style.fill = 'currentColor';
        paths[1].setAttribute('d', "M137.4 470.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128zM109.3 352H210.7L160 402.7 109.3 352z");
        paths[1].style.fill = '#CCCCCC';  // Light gray for unfilled arrow
    } else if (direction === 'desc') {
        paths[0].setAttribute('d', "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zM109.3 160H210.7L160 109.3 109.3 160z");
        paths[0].style.fill = '#CCCCCC';  // Light gray for unfilled arrow
        paths[1].setAttribute('d', "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z");
        paths[1].style.fill = 'currentColor';
    } else {
        paths[0].setAttribute('d', "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zM109.3 160H210.7L160 109.3 109.3 160z");
        paths[0].style.fill = '#CCCCCC';  // Light gray for unfilled arrow
        paths[1].setAttribute('d', "M137.4 470.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128zM109.3 352H210.7L160 402.7 109.3 352z");
        paths[1].style.fill = '#CCCCCC';  // Light gray for unfilled arrow
    }
}

// Function to create arrow SVG
function createArrowSVG() {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    svg.setAttribute("role", "img");
    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    svg.setAttribute("viewBox", "0 0 320 512");

    svg.style.height = '12px';
    svg.style.marginLeft = '1rem';
    svg.style.flexShrink = '0'; // Prevent the SVG from shrinking

    for (let i = 0; i < 2; i++) {
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.style.fill = '#CCCCCC';  // Start with light gray for both arrows
        svg.appendChild(path);
    }

    return svg;
}

// Function to initialize sortable tables
function initSortableTables() {
    const tables = document.querySelectorAll('table[data-sortable]');

    tables.forEach((table) => {
        const headers = table.querySelectorAll('th');
        const initialSortKey = table.dataset.initialSortColumn;
        const initialSortDirection = table.dataset.initialSortDirection || 'desc';

        headers.forEach((header) => {
            const sortableElements = header.querySelectorAll('[data-sortable-key]');

            sortableElements.forEach(element => {
                const sortKey = element.dataset.sortableKey;
                const headerText = element.textContent;

                // Store original styles
                const computedStyle = window.getComputedStyle(element);
                const originalTextAlign = computedStyle.textAlign;
                const originalJustifyContent = computedStyle.justifyContent;

                // Clear the element's content
                element.innerHTML = '';

                // Create a container for the content to preserve alignment
                const contentContainer = document.createElement('div');
                contentContainer.style.display = 'flex';
                contentContainer.style.alignItems = 'center';
                contentContainer.style.width = '100%';
                contentContainer.style.justifyContent = originalJustifyContent !== 'normal' ? originalJustifyContent :
                    (originalTextAlign === 'right' ? 'flex-end' :
                        originalTextAlign === 'center' ? 'center' : 'flex-start');

                const textSpan = document.createElement('span');
                textSpan.textContent = headerText;
                contentContainer.appendChild(textSpan);

                const svg = createArrowSVG();
                contentContainer.appendChild(svg);

                // Set styles for the main element
                element.style.display = 'flex';
                element.style.alignItems = 'center';
                element.style.cursor = 'pointer';
                element.appendChild(contentContainer);

                // Set initial sort state
                if (sortKey === initialSortKey) {
                    element.dataset.sortDirection = initialSortDirection;
                    updateSvgState(svg, initialSortDirection);
                } else {
                    element.dataset.sortDirection = '';
                    updateSvgState(svg, '');
                }

                element.addEventListener('click', () => {
                    const currentDirection = element.dataset.sortDirection || '';
                    let newDirection;
                    if (currentDirection === '') {
                        newDirection = 'desc';
                    } else {
                        newDirection = currentDirection === 'desc' ? 'asc' : 'desc';
                    }
                    sortTable(table, sortKey, newDirection);
                });
            });
        });

        // Perform initial sort if specified
        if (initialSortKey) {
            sortTable(table, initialSortKey, initialSortDirection);
        }
    });
}

// Initialize sortable tables when the DOM is loaded
document.addEventListener('DOMContentLoaded', initSortableTables);

// TABLE COLUMNS SELECTOR

function setupColumnToggles() {
    const toggleLists = document.querySelectorAll('[data-column-toggles-for]');

    toggleLists.forEach(list => {
        const tableId = list.getAttribute('data-column-toggles-for');
        const table = document.getElementById(tableId);

        function toggleColumn(columnName, visible) {
            const columnIndex = Array.from(table.querySelectorAll('th'))
                .findIndex(th => th.getAttribute('data-toggleable-column-title') === columnName);
            if (columnIndex === -1) return; // Column not found or not toggleable

            const rows = table.querySelectorAll('tr');
            rows.forEach(row => {
                const cell = row.cells[columnIndex];
                if (cell) {
                    cell.style.display = visible ? '' : 'none';
                }
            });
        }

        function updateLocalStorage(columns) {
            localStorage.setItem(`shownColumns_${tableId}`, JSON.stringify(columns));
        }

        function loadColumnVisibility() {
            const stored = localStorage.getItem(`shownColumns_${tableId}`);
            return stored ? JSON.parse(stored) : null;
        }

        let columns = loadColumnVisibility() || {};

        const headers = table.querySelectorAll('th[data-toggleable-column-title]');
        list.innerHTML = ''; // Clear existing toggles

        headers.forEach((header, index) => {
            const columnName = header.getAttribute('data-toggleable-column-title');
            const defaultVisible = header.getAttribute('data-default-visible') === 'true';
            if (!(columnName in columns)) {
                columns[columnName] = defaultVisible;
            }

            const li = document.createElement('li');
            li.className = 'px-4 py-2 hover:bg-gray-100 flex items-center space-x-2';

            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.id = `column-toggle-${tableId}-${index}`;
            checkbox.checked = columns[columnName];
            checkbox.className = 'form-checkbox h-5 w-5 text-blue-600 flex-shrink-0';

            const label = document.createElement('label');
            label.htmlFor = checkbox.id;
            label.className = 'text-sm text-gray-700 truncate flex-grow cursor-pointer';
            label.appendChild(document.createTextNode(columnName));

            li.appendChild(checkbox);
            li.appendChild(label);
            li.setAttribute('role', 'menuitemcheckbox');
            li.setAttribute('aria-checked', checkbox.checked);
            list.appendChild(li);

            function updateColumnVisibility() {
                columns[columnName] = checkbox.checked;
                toggleColumn(columnName, checkbox.checked);
                li.setAttribute('aria-checked', checkbox.checked);
                updateLocalStorage(columns);
            }

            checkbox.addEventListener('change', (event) => {
                event.stopPropagation();
                updateColumnVisibility();
            });

            toggleColumn(columnName, columns[columnName]);
        });
    });
}

document.addEventListener('DOMContentLoaded', setupColumnToggles);

// ACTION MENU

function setupActionMenus() {
    const toggleButtons = document.querySelectorAll('[aria-controls]');

    toggleButtons.forEach(button => {
        const menuId = button.getAttribute('aria-controls');
        const menu = document.getElementById(menuId);

        // Initially hide the menu
        menu.style.display = 'none';

        button.addEventListener('click', (event) => {
            event.stopPropagation();
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            button.setAttribute('aria-expanded', !isExpanded);
            menu.style.display = isExpanded ? 'none' : 'block';
        });

        document.addEventListener('click', () => {
            button.setAttribute('aria-expanded', 'false');
            menu.style.display = 'none';
        });

        menu.addEventListener('click', (event) => {
            event.stopPropagation();
        });
    });
}

document.addEventListener('DOMContentLoaded', setupActionMenus);

